// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Te","info":"i_Tf","doughnut":"i_Tg","title":"i_Th","points":"i_Ti","target":"i_Tj","value":"i_Tk","suffix":"i_Tl"};